'use client'

import { ReactNode } from 'react'
import { AppSpinner } from '@/components/layout/app-spinner'

interface LoadingScreenProps {
  message?: string
  children?: ReactNode
  /**
   * Whether to fade out the loading screen
   * @default false
   */
  fadeOut?: boolean
  /**
   * The variant style of the spinner
   * @default "default"
   */
  variant?: "default" | "secondary" | "muted"
}

export function LoadingScreen({ 
  message = 'Loading application...', 
  children,
  fadeOut = false,
  variant = "default"
}: LoadingScreenProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background transition-opacity duration-500 ease-in-out">
      <div className="w-full max-w-md p-8 space-y-6 text-center">
        <AppSpinner 
          size="xl" 
          variant={variant} 
          fadeOut={fadeOut} 
          message={message}
        />
        
        {children && (
          <div className={`text-sm text-muted-foreground transition-opacity duration-500 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}>
            {children}
          </div>
        )}
      </div>
    </div>
  )
} 